import React from 'react'
import { Badge } from 'react-bootstrap'

interface PillsDatasetProps {
  datasetNames: string[]
  onToggleDataset?: (datasetName: string) => void
  className?: string
  tiny?: boolean
  disabled?: boolean
}

const PillsDataset: React.FC<PillsDatasetProps> = ({
  datasetNames,
  onToggleDataset,
  className,
  tiny = false,
  disabled = false,
}) => {
  const formatDatasetName = (name: string): string => {
    const baseName = name.split(':')?.[0] || name
    if (baseName.length > 15) {
      return `${baseName.slice(0, 4)}...${baseName.slice(-4)}`
    }
    return baseName
  }

  return (
    <div
      className={`dataset-pills ${className || ''}`}
      style={{ display: 'flex', flexWrap: 'wrap', gap: '0.5rem' }}
    >
      {datasetNames &&
        datasetNames?.map((datasetName, index) => (
          <div
            key={`${datasetName}-${index}`}
            onClick={() => (disabled ? {} : onToggleDataset ? onToggleDataset(datasetName) : {})}
            style={{
              backgroundColor: '#800085', // Purple color as requested
              color: 'white', // White text for contrast
              padding: tiny ? '.1rem 1rem' : '0.5rem 1rem',
              marginTop: tiny ? '.2rem' : '.5rem',
              height: tiny ? '1.2rem' : '1.75rem',
              borderRadius: '9999px',
              fontSize: tiny ? '.8rem' : '1rem',
              fontWeight: tiny ? '' : '',
              display: 'flex',
              alignItems: 'center',
              justifyContent: 'center',
              cursor: 'pointer',
              position: 'relative', // Add position relative to the pill
            }}
          >
            <span>{formatDatasetName(datasetName)}</span>
            {datasetName !== 'All' && (
              <>
                {/* Badge for indicating training dataset */}
                <Badge
                  bg="success"
                  style={{
                    position: 'absolute',
                    top: '-0.3rem',
                    right: '-0.3rem',
                    padding: tiny ? '.15rem .25rem' : '.25rem .5rem',
                    fontSize: tiny ? '.5rem' : '.7rem',
                    borderRadius: '100px',
                  }}
                >
                  {datasetName.split(':')[1] || 'Unk'}
                </Badge>
              </>
            )}
          </div>
        ))}
    </div>
  )
}

export default PillsDataset
